import OptionalSelection from '@/js/configuration-wizard/components/organisms/OptionalSelection/OptionalSelection';

export default OptionalSelection;
